import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { isKnownComponentProject } from '../config/componentProjects';

interface AdminComponentProjectFilterStore {
  /** `null` = all component projects (dashboard default). */
  componentProject: string | null;
  setComponentProject: (value: string | null) => void;
}

export const useAdminComponentProjectFilterStore = create<AdminComponentProjectFilterStore>()(
  persist(
    (set) => ({
      componentProject: null,
      setComponentProject: (value) => {
        if (value === null || isKnownComponentProject(value)) {
          set({ componentProject: value });
        }
      },
    }),
    { name: 'admin-component-project-filter' }
  )
);
